module.exports = __webpack_public_path__ + "static/media/help1.24a956bd.png";